// src/components/PracticeTest/FolderGrid.jsx

import React, { useMemo } from 'react';
import FolderCard from './FolderCard';

export default function FolderGrid({ posts, onFolderClick }) {
  const groupedData = useMemo(() => {
    return posts.reduce((acc, post) => {
      const tag = post.tag || "General";
      if (!acc[tag]) acc[tag] = [];
      acc[tag].push(post);
      return acc;
    }, {});
  }, [posts]);

  const categories = Object.keys(groupedData);

  if (categories.length === 0) {
    return <div className="animate-view empty-state">No folders found.</div>;
  }

  return (
    <div className="folders-grid animate-view">
      {categories.map(category => (
        <FolderCard 
          key={category}
          title={category}
          count={groupedData[category].length}
          onClick={() => onFolderClick(category)}
        />
      ))}
    </div>
  );
}